export const GIT_BRANCH = "master"
export const GIT_HASH = "c4939ad757f33b45f06aae984c25d315691c70a2"
export const BUILD_NUM = "master.2023.02.20.01"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const ASSETS_BASE_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/"
export const DEFAULT_API_URL = "https://api.flipdish.co/"
export const DEFAULT_PATH_EMBEDDED = "https://web-order.flipdish.co/production/embedded/latest/index.html"
